import { render, staticRenderFns } from "./tyyLiveSettingLists.vue?vue&type=template&id=5f2a8798&"
import script from "./tyyLiveSettingLists.vue?vue&type=script&lang=js&"
export * from "./tyyLiveSettingLists.vue?vue&type=script&lang=js&"
import style0 from "./tyyLiveSettingLists.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports